import Questionaires from "./Questionaires";;
import BaseApi from "../../BaseApi";

export default class AscendingAssessmentQuestionaires extends Questionaires {
    static getApiUrl() {
        return BaseApi.getApiVersionBasePath("v1")
            + "self-assessments";
    }
}